/**
 * Icon selector definition
 */
export enum IconName {
    Arrow = 'arrow',
    ArrowFull = 'arrowFull',
    ArrowOpen = 'arrowOpen',
    ArrowSlim = 'arrowSlim',
    BellOff = 'bellOff',
    BestSeat = 'bestSeat',
    BestSeatActive = 'bestSeatActive',
    Calendar = 'calendar',
    CalendarSmall = 'calendarSmall',
    Cart = 'cart',
    Checked = 'checked',
    Chevron = 'chevron',
    Close = 'close',
    Compass = 'compass',
    Cross = 'cross',
    Download = 'download',
    Eye = 'eye',
    Filter = 'filter',
    SmallFilter = 'smallFilter',
    Gdpr = 'gdpr',
    Interest = 'interest',
    Lang = 'lang',
    Location = 'location',
    Login = 'login',
    Logout = 'logout',
    Profile = 'profile',
    Search = 'search',
    SeatingChart = 'seatingChart',
    SeatingChartActive = 'seatingChartActive',
    Share = 'share',
    ThreeDots = 'threeDots',
    Time = 'time',
    Unchecked = 'unchecked',
    Plus = 'plus',
    Minus = 'minus',
    Info = 'information',
    Percentage = 'percentage',
    Slovenia = 'slovenia',
    Croatia = 'croatia',
    Bulgaria = 'bulgaria',
    Romania = 'romania',
    Hungary = 'hungary',
    UnitedKingdom = 'unitedKingdom',
}
